'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _roles = require('config/permissions/roles');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductsService = function () {
  function ProductsService($http) {
    'ngInject';

    _classCallCheck(this, ProductsService);

    this.$http = $http;
  }

  _createClass(ProductsService, [{
    key: 'setQuery',
    value: function setQuery(query) {
      this.query = query;
    }
  }, {
    key: 'getProducts',
    value: function getProducts() {
      return this.$http.get('/api/product/search_all', {
        params: _extends({}, this.query)
      });
    }
  }, {
    key: 'getProductsBySpecies',
    value: function getProductsBySpecies(species) {
      return this.$http.get('/api/product/search_by_species', {
        params: _extends({}, this.query, {
          selectedSpecies: species
        })
      });
    }
  }, {
    key: 'getProductsByMember',
    value: function getProductsByMember(memberId) {
      return this.$http.get('/api/product/search_by_member', {
        params: _extends({}, this.query, {
          memberId: memberId
        })
      });
    }
  }, {
    key: 'getProductsByIngredient',
    value: function getProductsByIngredient(ingredientId) {
      return this.$http.get('/api/product/search_by_ingredient', {
        params: _extends({}, this.query, {
          userIngredientId: ingredientId
        })
      });
    }
  }, {
    key: 'getProductsBySystemIngredient',
    value: function getProductsBySystemIngredient(ingredientId) {
      return this.$http.get('/api/product/search_by_system_ingredient', {
        params: _extends({}, this.query, {
          systemIngredientId: ingredientId
        })
      });
    }
  }, {
    key: 'getProductsMissingProductInfo',
    value: function getProductsMissingProductInfo() {
      return this.$http.get('/api/product/search_by_missing_product_info', {
        params: _extends({}, this.query)
      });
    }
  }, {
    key: 'getProductsMissingSalesData',
    value: function getProductsMissingSalesData() {
      return this.$http.get('/api/product/search_by_missing_sale_data', {
        params: _extends({}, this.query)
      });
    }
  }, {
    key: 'getAlerts',
    value: function getAlerts() {
      return this.$http.get('/api/alert/load_alert_product');
    }
  }, {
    key: 'updateMissingUsages',
    value: function updateMissingUsages(usages) {
      return this.$http.post('/api/usage/update_missing_usage', {
        usages: usages
      });
    }
  }, {
    key: 'removeSignature',
    value: function removeSignature(productId) {
      return this.$http.delete('/api/product/' + productId + '/sign');
    }
  }, {
    key: 'setDiscontinuedStatus',
    value: function setDiscontinuedStatus(productId, isDiscontinued) {
      return this.$http.put('/api/product/' + productId + '/discontinue', {
        productId: productId,
        isDiscontinued: isDiscontinued
      });
    }
  }, {
    key: 'getSearchTypes',
    value: function getSearchTypes() {
      return [{
        name: 'All Products',
        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.SYS_ADMIN]
      }, {
        name: 'Search by Ingredient Name',
        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.SYS_ADMIN]
      }, {
        name: 'Search by Species',
        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.SYS_ADMIN]
      }, {
        name: 'Missing - Containers Shipped Data',
        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.SYS_ADMIN]
      }, {
        name: 'Missing - Product Information',
        permission: ['' + _roles.USER, '' + _roles.COMPANY_ADMIN, '' + _roles.SYS_ADMIN]
      }, {
        name: 'Search by System Ingredient Name',
        permission: '' + _roles.SYS_ADMIN
      }, {
        name: 'Search by Member',
        permission: '' + _roles.SYS_ADMIN
      }];
    }
  }, {
    key: 'getLabelThumbnail',
    value: function getLabelThumbnail(productId) {
      return this.$http.get('/api/product_label/' + productId + '/thumbnail');
    }
  }, {
    key: 'getLabel',
    value: function getLabel(productId) {
      return this.$http.get('/api/product_label/' + productId + '/request');
    }
  }, {
    key: 'getLabelImage',
    value: function getLabelImage(productId) {
      return this.$http.get('/api/product_label/' + productId);
    }
  }]);

  return ProductsService;
}();

exports.default = ProductsService;


// WEBPACK FOOTER //
// ./components/app/products/products.service.js